import { PermissionContext, getPermissionContextForFirm } from '@common/util/permissions'
import { useFirm } from '~/components/hooks/useFirm'

export function usePermissionContext(): PermissionContext {
  const firm = useFirm()
  return getPermissionContextForFirm(firm)
}
